module.exports = __webpack_public_path__ + "img/weightlifting_orig_07-28-2021.21534586.jpg";